import React from 'react';
import PropTypes from "prop-types"
import Icon from '@mdi/react';
import { mdiEmail, mdiInstagram, mdiTwitter, mdiFacebook } from '@mdi/js';

const SocialLinks = props => {
  const { customClass, showFullEmail } = props
  return (
    <div className={customClass}>
      <a href="mailto:hello@planetargon.com" className="is-header-link" >
        {showFullEmail && <span className="email-text has-text-white">hello@planetargon.com</span>}
        <Icon path={mdiEmail} size={1} color="" className="email-icon" title="Contact Planet Argon via Email" />
      </a>

      <a href="https://www.instagram.com/planetargon/" target="_blank" rel="noreferrer" className="is-header-link">
        <Icon path={mdiInstagram} size={1} color="" title="Follow Planet Argon on Instagram" />
      </a>

      <a href="https://twitter.com/planetargon" target="_blank" rel="noreferrer"  className="is-header-link">
        <Icon path={mdiTwitter} size={1} color="" title="Follow Planet Argon on Twitter" />
      </a>

      <a href="https://www.facebook.com/planetargon" target="_blank" rel="noreferrer"  className="is-header-link">
        <Icon path={mdiFacebook} size={1} color="" title="Follow Planet Argon on Facebook" />
      </a>
    </div>
  )
}

SocialLinks.propTypes = {
  customClass: PropTypes.string,
  showFullEmail: PropTypes.bool
}

SocialLinks.defaultProps = {
  customClass: "is-header-links",
  showFullEmail: true
}

export default SocialLinks